/**
 * @generated SignedSource<<aa777c604269fcffbe2ca7dcaf95b92f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StorePermissions = "FILE_ADMIN" | "PLU_ADMIN" | "ROUTINE_ADMIN" | "STORECAST_ADMIN" | "TEAM_ADMIN" | "USER_ADMIN";
import { FragmentRefs } from "relay-runtime";
export type usePermissions_store$data = {
  readonly id: string;
  readonly myPermissions: ReadonlyArray<StorePermissions>;
  readonly " $fragmentType": "usePermissions_store";
};
export type usePermissions_store$key = {
  readonly " $data"?: usePermissions_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePermissions_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePermissions_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myPermissions",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "7d79581602d8103743f5cf1f5b8e1336";

export default node;
